"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkBuilderFactory = void 0;
var LinkBuilder_1 = require("./LinkBuilder");
/* eslint-disable class-methods-use-this */
var LinkBuilderFactory = /** @class */ (function () {
    function LinkBuilderFactory() {
    }
    LinkBuilderFactory.prototype.make = function () {
        return new LinkBuilder_1.LinkBuilder();
    };
    return LinkBuilderFactory;
}());
exports.LinkBuilderFactory = LinkBuilderFactory;
//# sourceMappingURL=LinkBuilderFactory.js.map